import React, { useState, useEffect } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import LockIcon from '@mui/icons-material/Lock';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';
const theme = createTheme();
import { Backdrop, CircularProgress, Snackbar } from '@mui/material';
import { login, SetUser } from "../../services/auth";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import { LoginAdmAPI } from "../../services/User";
import { isMobile } from "../../utils/isMobile";
import { Colors } from "../../constants/Colors";


const LOGO_URL = 'http://www.ijobtech.com/images/ijoblogo02.png'
const LOGO2_URL = 'http://www.ijobtech.com/images/ijoblogo09.png'
function Copyright ()
{
  return (
    <Typography variant="body2" color="textSecondary" align="center" style={ { margin: '2rem 0 0 0' } }>
      { 'Copyright © ' }
      <Link color="inherit" href="https://material-ui.com/">
        iJob
      </Link>{ ' ' }
      { new Date().getFullYear() }
      { '.' }
    </Typography>
  );
}

const useStyles = makeStyles( ( theme ) => ( {
  root: {
    height: '100vh',
    backgroundColor: '#fff',
  },
  image: {
    backgroundImage: `url(${ LOGO_URL })`,
    backgroundRepeat: 'no-repeat',

    backgroundSize: 'contain',
    backgroundPosition: 'center',

  },
  paper: {
    margin: 4,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  paperMobile: {
    margin: 3,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: 1,
    //backgroundColor: Colors.White,
    //marginBottom: '0.1px'
  },
  avatar: {
    margin: '1rem 0 0 0',
    backgroundColor: Colors.LightGray,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    //high: '100',
    marginTop: 1,
  },
  submit: {
    margin: 3,
  },
} ) );

export default function SignIn ( props )
{
  const classes = useStyles();
  const [ Email, setEmail ] = React.useState( '' )
  const [ Password, setPassword ] = useState( '' )
  const [ Error, setError ] = useState( '' )

  const [ state, setState ] = React.useState( { open: false, vertical: 'top', horizontal: 'center', } )
  const [ ShowPassword, setShowPassword ] = useState( false );
  const [ SnackMessage, setSnackMessage ] = React.useState( '' )
  const { vertical, horizontal, open } = state
  const [ openBackground, setOpenBackground ] = React.useState( false );
  const useIsMobile = isMobile();

  useEffect( () =>
  {
    console.log( useIsMobile )
  }, [ useIsMobile ] );

  function ShowSnackBar ( text, vertical = "bottom", horizontal = "center" )
  {
    setSnackMessage( text );
    setState( { open: true, vertical, horizontal } );
  }

  async function handleSignIn ( e )
  {
    e.preventDefault();

    if ( !Email || !Password )
    {
      setError( "Preencha e-mail e senha para continuar!" );
    }
    else
    {
      try
      {
        setOpenBackground( true )

        const response = await LoginAdmAPI( Email, Password );

        console.log( response );

        if ( response != undefined && response.Sucesso )
        {
          login( response.IdCliente );
          SetUser( response.Nome )
          props.history.push( "/app" );
        }

        else if ( response === undefined )
        {
          ShowSnackBar( "Não foi possível concluir a operação, tente novamente mais tarde." );
        }

        else if ( response.Sucesso === false )
        {
          ShowSnackBar( "Houve um problema com o login, verifique suas credenciais. " );

        }

      }
      catch ( err )
      {
        ShowSnackBar( "Houve um problema com o login, verifique suas credenciais. " );
      }
      finally
      {
        setOpenBackground( false )
      }
    }
  }

  function handleClose ()
  {
    setState( { ...state, open: false } );
  }

  return (

    useIsMobile ?

      <div style={ { display: 'flex' } }>
        <CssBaseline />

        <div className={ classes.paperMobile }>
          <img src={ LOGO2_URL } style={ { resizeMode: 'cover', height: '10%', width: '35%', marginTop: '2rem' } } />
          <Avatar className={ classes.avatar }>

            <LockIcon color='primary' />
          </Avatar>

          <Typography component="h1" variant="h5">Entrar</Typography>

          <form className={ classes.form } noValidate onSubmit={ handleSignIn }>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email"
              name="email"
              autoComplete="email"
              autoFocus
              onChange={ e => { setEmail( e.target.value ) } }
            />

            <TextField
              variant="outlined" margin="normal" required fullWidth name="password" label="Senha"
              type={ ShowPassword ? "text" : "password" }
              id="password"
              InputProps={ {
                endAdornment: (
                  <InputAdornment
                    position="end"
                    style={ { flex: 1, display: "flex" } }
                  >
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={ () => setShowPassword( !ShowPassword ) }
                    >
                      { ShowPassword ? <Visibility /> : <VisibilityOff /> }
                    </IconButton>
                  </InputAdornment>
                ),
              } }
              autoComplete="current-password"
              onChange={ ( e ) =>
              {
                setPassword( e.target.value );
              } }
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={ classes.submit }>Login
            </Button>

            <Copyright />
          </form>
          <Snackbar
            anchorOrigin={ { vertical, horizontal } }
            open={ open }
            onClose={ handleClose }
            message={ SnackMessage }
            key={ vertical + horizontal }
            autoHideDuration={ 3000 }
          />
          <Backdrop style={ { zIndex: 5, color: '#fff' } } open={ openBackground }>
            <CircularProgress color="inherit" />
          </Backdrop>



        </div>


      </div>


      :

      <Grid container component="main" className={ classes.root } >
        <CssBaseline />

        <div style={ { display: 'flex', flex: 1, justifyContent: 'center', backgroundImage: `url(${ 'https://i.imgur.com/GH6qE9N.jpg' })` } }>
          <Grid item xs={ false } sm={ 0 } md={ 5 } className={ classes.image } />
        </div>

        <Grid item xs={ 12 } sm={ 10 } md={ 5 } component={ Paper }  >
          <div className={ classes.paper }>
            <img src={ LOGO2_URL } style={ { resizeMode: 'cover', height: '10%', width: '35%' } } />
            <Avatar className={ classes.avatar }>

              <LockIcon color='primary' />
            </Avatar>

            <Typography component="h1" variant="h5">Entrar</Typography>

            <form className={ classes.form } noValidate onSubmit={ handleSignIn }>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                autoFocus
                onChange={ e => { setEmail( e.target.value ) } }
              />

              <TextField
                variant="outlined" margin="normal" required fullWidth name="password" label="Senha"
                type={ ShowPassword ? "text" : "password" }
                id="password"
                InputProps={ {
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={ { flex: 1, display: "flex" } }
                    >
                      <IconButton
                        aria-label="Toggle password visibility"
                        onClick={ () => setShowPassword( !ShowPassword ) }
                      >
                        { ShowPassword ? <Visibility /> : <VisibilityOff /> }
                      </IconButton>
                    </InputAdornment>
                  ),
                } }
                autoComplete="current-password"
                onChange={ ( e ) =>
                {
                  setPassword( e.target.value );
                } }
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={ classes.submit }>Login
              </Button>

              <Copyright />
            </form>
            <Snackbar
              anchorOrigin={ { vertical, horizontal } }
              open={ open }
              onClose={ handleClose }
              message={ SnackMessage }
              key={ vertical + horizontal }
              autoHideDuration={ 3000 }
            />
            <Backdrop style={ { zIndex: 1, color: '#fff' } } open={ openBackground }>
              <CircularProgress color="inherit" />
            </Backdrop>

          </div>

        </Grid>

      </Grid>

  );
}